import React, { useState, useEffect } from "react";
import { Col, Row, Pagination, Modal} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Input, PaginationItem, PaginationLink } from "reactstrap";
import { Link, Navigate, useLocation, useNavigate, useOutletContext, useParams } from "react-router-dom";
import { FormGroup, Spinner } from "react-bootstrap";
import TableData from "./TableData";
import { getItemsById, getItemsOfCurrentOwnerById, sellItemsCurrentOwner } from "store/actions";
import { Oval } from 'react-loader-spinner';
import PrintComp from "./PrintComp";


// import { tab } from "@testing-library/user-event/dist/tab";


export default function NftCreate(props) {
  const [menu, menuopen] = useOutletContext();
  useEffect(() => {
    menu(false)
  }, [menu])
  const [printDialog, setprintDialog] = useState(false)
  const currentOwner = useSelector((state) => state?.SellItems?.sellItemsCurrentOwner);
  const { loading } = useSelector((state) => state?.SellItems);
  const current_owner = useSelector((state) => state?.Login?.user?._id);
  const dispatch = useDispatch()
  const location = useLocation();
  const pagepath = location.pathname.split('/')
  const [search, setSearch] = useState('')
  const activepath = pagepath.filter((res) => res === 'soldbyartist')
  const pagesoldbyartist = activepath[0]
  const navigate = useNavigate();
  const { authToken, user } = useSelector((state) => state?.Login);
  const [numArray, setNumArray] = useState([])
  const { item } = useSelector((x) => x?.items)

  const [soldNft, setSoldNfts] = useState([])
  const [mintedNft, setmintedNft] = useState([])
  const Redirect = () => {
    const GetAddress = localStorage.getItem("walletAddress");
    if (GetAddress) {
      navigate("../nft/createnft");
    } else {
      navigate("/metamask-sign");
    }
  };
  const [data, setData] = useState([])
  const [currentOwner2, setCurrentOwner2] = useState([])
  const [tabs, settabs] = useState("Minted");
  const [timezone, setTimezone] = useState()
  // const [fields, setFields] = useState({
  //   limit: 10000000,
  //   order: -1,
  //   fields: [{
  //     fieldName: "status",
  //     fieldValue: true
  //   },
  //   {
  //     fieldName: "owner_id",
  //     fieldValue: current_owner
  //   }
  //   ]
  // });
  useEffect(() => {
    const timezoneString = Intl.DateTimeFormat().resolvedOptions().timeZone;
    setTimezone(timezoneString)
  }, [])
  useEffect(() => {
    if(current_owner){
      let body = {}
    body.owner_id = current_owner
    dispatch(sellItemsCurrentOwner(body));
    }
  }, [current_owner, dispatch]);

  useEffect(() => {
    if (tabs === "Minted") {
      setCurrentOwner2(currentOwner)
      setData(mintedNft)
    }
    else {
      setData(soldNft)
    }
  }, [currentOwner, tabs, soldNft, mintedNft]);


  useEffect(() => {
  }, [item])
  useEffect(() => {
    dispatch(getItemsOfCurrentOwnerById({ current_owner: current_owner }));

  }, [current_owner]);
  useEffect(() => {
    let last_value = 0
    last_value = [parseInt(Math.ceil((data ? data.length : 0) / 10))]
    let arr = []
    for (let i = 1; i <= last_value; i++) {
      arr.push(i)
    }
    setNumArray(arr)

  }, [data]);

  useEffect(() => {

    let value = 1
    value = parseInt(value)

    let x = (value * 10) - 10
    let datas = []
    for (let i = x; i < value * 10; i++) {
      if (data[i]) {
        datas.push(data[i])
      }
    }
  }, [data])


  useEffect(() => {
    if (tabs === "Minted") {
      setmintedNft(currentOwner.filter((item) => item?.status === true || (item?.available_copies > 0 && item.sale_status == "expired")))
    }
    else {
      setSoldNfts(currentOwner.filter((item) =>  item?.available_copies === 0))
    }
  }, [currentOwner, tabs])

  useEffect(() => {
    if (tabs === "Minted") {
      setData(mintedNft?.filter((item) => { return search.toLowerCase() === '' ? item : item?.nft_id?.name.toLowerCase().includes(search.toLowerCase()) }))
    }
    else {
      setData(soldNft?.filter((item) => { return search.toLowerCase() === '' ? item : item?.nft_id?.name.toLowerCase().includes(search.toLowerCase()) }))
    }
  }, [search, mintedNft, tabs, soldNft])

  // <-------------nft print-------------->
  const [selectedNft, setSelectedNft] = useState({})
  const printnftbtn = (item) => {
    setSelectedNft(item)
    setprintDialog(!printDialog)
  };


  /// pagination
  const [dataLength, setDataLength] = useState([])
  const [dataAfterPagination, setDataAfterPagination] = useState([])
  var [values, setValues] = useState(10)
  var [sNoValue, setSNovalue] = useState(0)
  useEffect(() => {
    var x = 0
    if (data?.length < 9) {
      x = 1
    } else {
      x = Math.ceil((data.length) / 10)
    }
    for (let i = 1; i <= x; i++) {
      if (!dataLength.includes(i)) {
        dataLength.push(i)
      }
    }
  }, [data, search])


  useEffect(() => {
    let arr = []
    setSNovalue(values - 10)
    for (let i = (values - 10); i < values; i++) {
      if (data[i]) {
        arr.push(data[i])
      }
    }
    setDataAfterPagination(arr)
    console.log('data', dataAfterPagination);
    
  }, [values, data, search])



  const handlePagination = (val) => {
    var valu = 0
    if (val === "<<") {
      valu = 10
    }
    else if (val === "<") {
      valu = ((parseInt(values) - 10))
    }
    else if (val === ">" && (sNoValue / 10) < values) {
      valu = ((parseInt(values / 10) + 1) * 10)
    }
    else if (val === ">>" && values < data.length) {
      // setSNovalue(data.length)
      valu = Math.ceil((data.length) / 10) * 10
    } else {
      valu = (parseInt(val) * 10)
    }
    setValues(valu)
  }
  useEffect(() => {
    setDataLength([1]);
    setValues(10)

  }, [search])
  const Artisttabs = (name) => {
    settabs(name);
  };


  return (
    <>
      {loading &&
        <div className='loaderBoxMiane'>
          <Oval
            height={80}
            width={80}
            color="#6C63FF"
            wrapperStyle={{}}
            wrapperClass=""
            visible={true}
            ariaLabel='oval-loading'
            secondaryColor="#6C63FF"
            strokeWidth={2}
            strokeWidthSecondary={2}
          />
        </div>
      }

      <Modal className="EmailVerifyBoxModel printDialog text-center" show={printDialog} centered animation={false}>

        <PrintComp fucn={printnftbtn} nftDet={selectedNft} />
      </Modal>


      <Row>
        <Col lg={12} className="mb-4">
          <div className="d-flex w-100 align-items-center justify-content-between flex-wrap">
            <h1 className="mb-0"><i onClick={menuopen} className="fa-light fa-bars-sort"></i>View Artworks</h1>
            {authToken &&
              (user?.role === "MUSEUM" || user?.role === "ARTIST") &&
              user?.verificationProfileStatus === "accept" && (
                <button onClick={Redirect} className="btn btn-secondary text-white fw-semibold px-5"> <i className="fa-light fa-plus"></i> List on Marketplace</button>
              )}
          </div>
        </Col>
      </Row>
      <Row>
        <Col lg={12}>
          <div className="TabsBox">
            <Row className="justify-content-between">
              <Col lg={12}>
                <div className="artTab mb-4">
                  <ul>
                    <li
                      onClick={() => Artisttabs("Minted")}
                      className={tabs === "Minted" ? "active" : ""}
                    >
                      Minted
                    </li>
                    <li
                      onClick={() => Artisttabs("Sold")}
                      className={tabs === "Sold" ? "active" : ""}
                    >
                      Sold
                    </li>
                  </ul>
                </div>
              </Col>
            </Row>
            {currentOwner.length > 0 ? (
              <div className="TabsData mt-4">
                <Row className="justify-content-between">
                  <Col lg={6}>
                    <FormGroup className="position-relative">
                      <Input onChange={(e) => setSearch(e.target.value)} className="form-control searchInput" placeholder="Search" />
                      <button className="btn position-absolute end-0 top-0 bottom-0 my-auto border-0"><i className="fa-light fa-magnifying-glass"></i></button>
                    </FormGroup>
                    {/* <p className="pdecription ">Showing 350 {pageName === 'nft' ? 'NFT’s' : 'Collections'}</p> */}
                  </Col>
                  {/* <Col lg={4}>
                                        <div className="d-flex align-item-center gap-3">
                                            <Input type="select" className="form-control searchInput shadow-none">

                                                <option>Low to High</option>
                                                <option>Low to High</option>
                                                <option>Low to High</option>

                                            </Input>
                                            <Input type="select" className="form-control searchInput shadow-none">
                                                <option>WEEKLY</option>
                                                <option>DAILY</option>
                                            </Input>
                                            <button className="btn border-0 clearfilter px-0">
                                                <i className="fa-solid fa-filter-circle-xmark"></i>
                                            </button>
                                        </div>
                                    </Col> */}
                </Row>

                <Row>
                  <Col lg={12}>

                    <div className="table-responsive tableNft">
                      <table>
                        <thead>
                          <tr>
                            <td className="text-left" id="text-left" style={{width:"4rem !important"}}>No.</td>
                            <td>Artwork Name</td>
                            <td className="text-center">Sold Artworks</td>
                            {/* <td className="text-center">Total Owners</td> */}
                            <td className="text-center">Available Artworks</td>
                            <td className="text-center">Edition Size</td>
                            <td className="text-center">Sale Type</td>
                            {/* auction/fixed */}
                            <td className="text-center">Date</td>
                            <td className="text-center">Status</td>
                            <td className="text-center">Action</td>
                          </tr>
                        </thead>
                        <tbody>

                          {dataAfterPagination.length > 0 ?
                            (dataAfterPagination?.map((item, index) =>
                              <tr>
                                <td className="text-left" >{sNoValue += 1}</td>
                                <td>
                                <div className="d-flex gap-2 align-items-center">
                                <div>
                                  <img className="nftimge" alt="" src={item?.nft_id?.image_id?.image?.link} />
                                  </div>
                                <div>
                                <span>{item?.nft_id?.name}</span>
                                </div>
                                </div>
                                </td>
                                <td className="text-center">{Number(item?.no_of_copies) - Number(item?.available_copies)}</td>
                                <td className="text-center">{item?.available_copies}</td>
                                <td className="text-center">{item?.no_of_copies}</td>
                                <td className="text-center text-capitalize">{item?.sellType}</td>
                                {/* <td className="text-center">None</td> */}

                                {/* <td className="text-center text-capitalize">{item?.created_date}</td> */}
                                {(item?.status === true) || (item?.available_copies > 0 && item.sale_status == "expired") ?
                                  <td className="text-center text-capitalize">{new Date(item?.created_date).toLocaleString('en-IN', { month: 'short', day: 'numeric', year: 'numeric', hour: 'numeric', minute: 'numeric', hour12: true, timezone: timezone })}</td> : <td className="text-center text-capitalize">{new Date(item?.sold_date).toLocaleString('en-IN', { month: 'short', day: 'numeric', year: 'numeric', hour: 'numeric', minute: 'numeric', hour12: true, timezone: timezone })}</td>
                                }
                                <td className="text-center">
                                  {pagesoldbyartist === 'soldbyartist' ? (<button className="statusbtt pendingstatus text-capitalize">Pending</button>) : (
                                    // <button className="statusbtt onsale">On Sale</button>
                                    <button className="statusbtt onsale text-capitalize">{item?.sale_status}</button>
                                  )}
                                </td>
                                <td className="text-center d-flex align-items-center justify-content-center ">
                                  {/* <button className="btn border-0"><i className="fa-regular fa-pen-to-square"></i></button> */}
                                  <Link className="btn border-0 " to={`/profile/nft/viewNft/${item?._id}`}><i className="fa-regular fa-eye"></i></Link>
                                  <button className="btn border-0 "  onClick={()=>printnftbtn(item)} >   <i className="fa fa-print"></i></button>
                                  {/* <button className="btn border-0 no-padding-top"  onClick={()=>printnftbtn(item)} ><img src={"/images/png/proof_reading.png"} className="img-width" alt="" /></button> */}
                                </td>
                              </tr>)) : (<>
                                <tr>
                                  <td colSpan={8}>
                                    <div className="text-center d-grid justify-content-center dataNotFound py-5">
                                      <img src={"/images/svg/mpdatanft.svg"} className="mb-4" alt="Create collection" />
                                      <h3>No Digital Artwork Available</h3>
                                    </div>
                                  </td>
                                </tr>
                              </>)}
                          {/* {currentOwner && currentOwner.map((item, index)=>{
                        <tr> */}
                          {/* <td className="text-center">1</td>
                          <td><img className="nftimge" alt="" src={"../../images/png/artist4.png"} /> {item.name}</td>
                          <td className="text-center">1</td>
                          <td className="text-center">10</td>
                          <td className="text-center">1</td>
                          <td className="text-center">None</td>
                          <td className="text-center">
                            {pagesoldbyartist === 'soldbyartist' ? (<button className="statusbtt verifiesstatus">Verified</button>) : (
                              <button className="statusbtt onsale">On Sale</button>
                            )}
                          </td>
                          <td className="text-center">
                            <button className="btn border-0"><i className="fa-regular fa-pen-to-square"></i></button>
                            <button className="btn border-0 "><i className="fa-regular fa-eye"></i></button>
                          </td>
                        </tr>})} */}
                          {/* <tr>
                          <td className="text-center">1</td>
                          <td><img className="nftimge" alt="" src={"../../images/png/artist4.png"} /> Artwork Name</td>
                          <td className="text-center">1</td>
                          <td className="text-center">10</td>
                          <td className="text-center">1</td>
                          <td className="text-center">None</td>
                          <td className="text-center">
                            {(pagesoldbyartist === 'soldbyartist') ? (<button className="statusbtt rejectedstatus">Rejected</button>) : (
                              <button className="statusbtt onsale">On Sale</button>
                            )}
                          </td>
                          <td className="text-center">
                            <button className="btn border-0"><i className="fa-regular fa-pen-to-square"></i></button>
                            <button className="btn border-0 "><i className="fa-regular fa-eye"></i></button>
                          </td>
                        </tr> */}
                        </tbody>
                        {/* {
                          // numArray && numArray?.map((item, index) => { return <h1 id="1" onClick={() => handleTableClick(item)}>{item}</h1> })
                         <> { currentVal > firstVal && <h1 id="1" onClick={() => handleTableClick("<")}>{"<"}</h1>  } <h1 id="1" onClick={() => handleTableClick(firstVal)}>{firstVal}</h1> ............ <h1 id="1" onClick={() => handleTableClick(lastVal)}>{lastVal}</h1>  { currentVal < lastVal && <h1 id="1" onClick={() => handleTableClick(">")}>{">"}</h1>} </>
                        } */}
                      </table>
                    </div>

                  </Col>
                  {dataAfterPagination.length > 0 &&
                    <Col lg={12} className="text-end">
                      <Pagination className="paginationNew" aria-label="Page  navigation example">
                        {values > 10 &&
                          <div className="d-flex align-items-center gap-2">
                            <PaginationItem  >
                              <PaginationLink
                                first
                                href="#"
                                onClick={() => handlePagination("<<")}
                              />
                            </PaginationItem>
                            <PaginationItem >
                              <PaginationLink
                                href="#"
                                previous
                                onClick={() => handlePagination("<")}
                              />
                            </PaginationItem>
                          </div>
                        }
                        {dataLength && dataLength.map((item) =>
                          <PaginationItem className={parseInt(item) === (values / 10) ? "active" : ""}  >
                            <PaginationLink href="#" onClick={() => handlePagination(item)}>
                              {item}
                            </PaginationLink>
                          </PaginationItem>
                        )}

                        {values < data.length &&
                          <div className="d-flex align-items-center gap-2">
                            <PaginationItem>
                              <PaginationLink
                                href="#"
                                next
                                onClick={() => handlePagination(">")}
                              />
                            </PaginationItem>
                            <PaginationItem>
                              <PaginationLink
                                href="#"
                                last
                                onClick={() => handlePagination(">>")}
                              />
                            </PaginationItem>
                          </div>
                        }
                      </Pagination>
                    </Col>}
                </Row>
              </div>)
              : (

                <div className="text-center d-grid justify-content-center dataNotFound py-5">
                  <img src={"../../images/svg/mpdatanft.svg"} alt="Create collection" />
                  <h3>No Digital Artwork Available</h3>
                  {/* {authToken &&
                    (user?.role === "MUSEUM" || user?.role === "ARTIST") &&
                    user?.verificationProfileStatus === "accept" && (
                      <button 
                      ={Redirect} className="btn btn-primary px-5"> <i className="fa-light fa-plus"></i> List on Marketplace</button>
                    )} */}
                </div>
              )
            }

          </div>

        </Col>
      </Row>
      {loading ? (<Spinner animation="border" size="sm" role="status"></Spinner>) : ('')}
    </>
  )
}